import styled from 'styled-components';

import Text from '../Text';

export const HeaderWithRuleContainer = styled.div`
	display: flex;
	align-items: center;

	hr {
		width: 100%;
	}
`;

export const HeaderWithRuleText = styled(Text)`
	padding: 0 0.5rem;
	text-transform: uppercase;
`;
